/* tslint:disable */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const CalendarIcon: React.SFC = () => {
    return (
    	<svg width="23" height="24">
    	<defs>
    	<rect id="a" width="4" height="5.65209961" x="15" rx="2"/>
    	<rect id="b" width="4" height="5.65209961" x="4" rx="2"/>
    	</defs>
    	<g fill="none" fillRule="evenodd">
    	<path fill="#F07662" d="M1 3h21c.5522847 0 1 .44771525 1 1v18c0 .5522847-.4477153 1-1 1H1c-.55228475 0-1-.4477153-1-1V4c0-.55228475.44771525-1 1-1zm2 3c-.55228475 0-1 .44771525-1 1v13c0 .5522847.44771525 1 1 1h17c.5522847 0 1-.4477153 1-1V7c0-.55228475-.4477153-1-1-1H3z"/>
    	<use fill="#FFF" xlinkHref="#a"/>
    	<rect width="3" height="4.65209961" x="15.5" y=".5" stroke="#F07662" rx="1.5"/>
    	<path fill="#F07662" d="M4 8h3v3H4zM4 12h3v3H4zM8 8h3v3H8zM8 12h3v3H8zM12 8h3v3h-3zM12 12h3v3h-3zM16 8h3v3h-3zM16 12h3v3h-3zM4 16h3v3H4zM8 16h3v3H8zM12 16h3v3h-3z"/>
    	<g>
    	<use fill="#FFF" xlinkHref="#b"/>
    	<rect width="3" height="4.65209961" x="4.5" y=".5" stroke="#F07662" rx="1.5"/>
    	</g>
    	</g>
    	</svg>

    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Calendar/Calendar.tsx